import { useEffect, useContext } from 'react'
import { FileUploader } from "react-drag-drop-files"

import { Typography } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { uploadClientImage } from '/providers/templates-api'

const GiftConfig = ({ setPrevButtonState, setNextButtonState, scannerData, setScannerData }) => {

  const { apiSource, apiKeys, setProcessing } = useContext(AppContext)
  
  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState("disabled")
    setScannerData(prev => {
      return {...prev,retailer_name:"",description:""}
    })
  }, [])

  useEffect(() => {
    let enabled = true

    if (!scannerData.logo.length) enabled = false

    setNextButtonState(enabled ? "enabled" : "disabled")
  },[scannerData])

  const handleImageUpload = file => {
    const filename = file.name

    const reader = new FileReader()
    reader.onloadend = async () => {
      const response = await doUploadToS3(filename, reader.result)

      setScannerData(prev => {
        return {...prev,logo:response.s3_url}
      })
    }
    reader.readAsDataURL(file)
  }

  const doUploadToS3 = async (filename, imageData) => {
    const base64Data = imageData.replace(/^data:image\/\w+;base64,/, '')
    setProcessing(true)
    const response = await uploadClientImage({ apiSource, apiKeys, device:"scan", imageType:"logo", filename, base64Data })
    //TODO handler error

    setProcessing(false)
    return response.image
  }

  const setValue = (value, field) => {
    let sd = _.cloneDeep(scannerData)
    _.set(sd, field, value)
    setScannerData(sd)
  }

  return (
    <>
      <Typography variant="h3" sx={{ p: 2 }}>Configure Gift Card</Typography>

      <div className='flex flex-col gap-5 mb-5'>
        <Typography variant="h5" sx={{ p: 2 }}>Logo Image</Typography>

        <div className='bg-white'>
          <img src={scannerData.logo} style={{ margin: "auto", marginTop: 10, marginBottom: 10 }}/>
        </div>

        <FileUploader handleChange={handleImageUpload} types={["png", "jpg", "jpeg"]} label="Click to select image, or drag an image here (1200x400)" />
      </div>
    </>
  )
}

export default GiftConfig